export interface StatusStyle {
  text: string;
  /** pill 樣式：背景 + 文字色（Tailwind class） */
  pill: string;
  /** 狀態小圓點背景（Tailwind class） */
  dot: string;
}

/** 狀態 → 柔和 pill 樣式（淺色底 + 深色字 + 小圓點），一律 Tailwind class。 */
export const STATUS: Record<string, StatusStyle> = {
  draft: { text: '草稿', pill: 'bg-[#f1f2f4] text-[#5b6470]', dot: 'bg-[#9aa3af]' },
  in_review: { text: '審稿中', pill: 'bg-[#fef3e2] text-[#b45a09]', dot: 'bg-[#f59e0b]' },
  scheduled: { text: '已排程', pill: 'bg-[#e8f1ff] text-[#1d5fc4]', dot: 'bg-[#3b82f6]' },
  published: { text: '已發佈', pill: 'bg-[#e7f6ee] text-[#0f7a44]', dot: 'bg-[#16a34a]' },
};

export const FALLBACK_STATUS: StatusStyle = {
  text: '',
  pill: 'bg-[#f1f2f4] text-[#5b6470]',
  dot: 'bg-[#9aa3af]',
};

export const STATUS_OPTIONS = Object.entries(STATUS).map(([value, { text }]) => ({
  value,
  label: text,
}));

export const KIND_OPTIONS = [
  { value: 'post', label: '文章' },
  { value: 'page', label: '頁面' },
];

export const fmtTaipei = (t: number | string) =>
  new Date(t).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' });
